import familyInfoReducer from "./reducers";
export { default as familyInfoTypes } from "./types";
export { default as familyInfoOperations } from "./operations";
export default familyInfoReducer;
